import axios from "axios";
import { NotImplementedError } from "../../../errors";
import { PromiseHandler } from "../../../handlers";
import { experimentFromService, optimizationHoldoutRequestToService } from "../../../models/experiments";
import { ExperimentBadRequestError } from "../errors";
import { validators } from "./validators";
import { ExperimentsHoldoutsEnd } from "./end";
/**
 * Optimization holdout experiments, created through their own endpoint.
 * Saving one returns the created experiment; they are read back through `experiments`.
 */
export class ExperimentsHoldouts extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "experiments.holdouts");
        this.validators = validators;
        this.url = `${this.sdk.urls.baseAPIUrl}/experiment/optimization-holdout`;
        this.end = new ExperimentsHoldoutsEnd(sdk);
    }
    /**
     * Creates and schedules (bypassing review) an optimization holdout
     * experiment: scoped to request.advertiserId, opted in for only
     * request.lineItemId, with a control and a "(KPI) Holdout" variant (split
     * set by the server) that disables request.kpi's optimization, with an
     * impression cap.
     * It waits as PUBLISHED and starts when the line item goes live.
     * POST /campaign-management/v1/experiment/optimization-holdout
     */
    async saveItem(request) {
        const errors = this.validate(request);
        if (errors.size) {
            throw new ExperimentBadRequestError(Array.from(errors.values()).join(", "));
        }
        const body = optimizationHoldoutRequestToService(request);
        const created = await axios
            .post(this.url, body, {
            headers: { "Content-Type": "application/json" }
        })
            .then(({ data: res }) => experimentFromService(res.data));
        // The new experiment belongs to the experiments cache, not this sub-module's.
        this.sdk.experiments.reconcileCache("save", created);
        return created;
    }
    async findItems() {
        throw new NotImplementedError("find — holdouts are read through experiments.find");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
//# sourceMappingURL=index.js.map